import { TextField, MenuItem } from '@mui/material';

const FormField = ({ label, name, type, value, onChange, readOnly, error, helperText, options, minDate }) => {
  const inputLabelProps = {};
  const htmlInputProps = {};
  if (type === "date") {
    inputLabelProps.shrink = true;

    htmlInputProps.min = minDate;
    htmlInputProps.max = new Date().toISOString().split("T")[0];
  }

  return (
    <TextField
      label={label}
      name={name}
      type={type || "text"}
      value={value}
      onChange={onChange}
      fullWidth
      margin="normal"
      select={type === "select"}
      required={!readOnly}
      variant={readOnly ? "filled" : "outlined"}
      slotProps={{
        inputLabel: inputLabelProps,
        htmlInput: htmlInputProps,
        input: {readOnly: readOnly}
      }}
      error={!!error}
      helperText={error || helperText}
    >
      {(options ?? []).map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label || option.value}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default FormField;